import { Observable } from 'rxjs'
import { filter, map, take, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { UtilityService } from 'src/app/core/utility.service'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import {
  GoogleFontFamily,
  GoogleFontsService
} from 'src/app/shared/services/google-fonts.service'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { environment } from 'src/environments/environment'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { ConfigurationOption } from '../../configuration-option'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { ConfigurationOptionService } from '../../configuration-option.service'

@Component({
  selector: 'configuration-option-main-branding',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionMainBrandingCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues: any
  @Input() isCollapsed: any = false
  //public isCollapsed = false

  public form: UntypedFormGroup
  public isLoading$: Observable<boolean>
  public primaryLogoUrl$: Observable<string>
  public primaryWhiteLogoUrl$: Observable<string>
  public faviconAdminPortalUrl$: Observable<string>
  public faviconConsumerFrontendUrl$: Observable<string>
  public primaryLogo: ConfigurationOption
  public primaryWhiteLogo: ConfigurationOption
  public faviconAdminPortal: ConfigurationOption
  public faviconConsumerFrontend: ConfigurationOption
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )
  public googleFonts$: Observable<GoogleFontFamily[]>
  public showCustomFontsOption: boolean

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private configurationOptionService: ConfigurationOptionService,
    private utilityService: UtilityService,
    public accessRightService: UserAccessRightService,
    private googleFontsService: GoogleFontsService
  ) {}
  config: any = {
    placeholder: '',
    tabsize: 2,
    height: '200px',
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }
  ngOnInit() {
    this.showCustomFontsOption = environment.branding.useCustomFonts
    if (this.showCustomFontsOption) {
      this.googleFonts$ = this.googleFontsService.getGoogleFontsList$()
      this.form = this.fb.group({
        browser_title: [null, []],
        custom_font_family: [null, []]
      })
    } else {
      this.form = this.fb.group({
        browser_title: [null, []]
      })
    }

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )

    this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(take(1))
      .subscribe()

    this.primaryLogoUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'primary_logo_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          this.primaryLogo = configOption
          return configOption.value.length
            ? `${environment.staticAssetBaseUrl}${configOption.value}`
            : ''
        })
      )

    this.primaryWhiteLogoUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'primary_white_logo_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          this.primaryWhiteLogo = configOption
          return configOption.value.length
            ? `${environment.staticAssetBaseUrl}${configOption.value}`
            : ''
        })
      )

    this.faviconAdminPortalUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'favicon_path_admin_portal'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          this.faviconAdminPortal = configOption
          return configOption.value?.length
            ? `${environment.staticAssetBaseUrl}${configOption.value}`
            : ''
        }),
        tap((url) => this.utilityService.setFavicon(url))
      )

    this.faviconConsumerFrontendUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'favicon_path_consumer_frontend'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          this.faviconConsumerFrontend = configOption
          return configOption.value?.length
            ? `${environment.staticAssetBaseUrl}${configOption.value}`
            : ''
        })
      )
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }

    this.onSubmit.emit(this.form.value)
  }

  public onSubmitLogo(file: File, configOptionKey) {
    this.configurationOptionService.saveOneWithFile(configOptionKey, file)
  }

  public onDeleteLogo(configOptionKey: string) {
    if (configOptionKey === 'primary_white_logo_image_path') {
      this.configurationOptionService.deleteOneWithFile(this.primaryWhiteLogo)
    } else if (configOptionKey === 'primary_logo_image_path') {
      this.configurationOptionService.deleteOneWithFile(this.primaryLogo)
    } else if (configOptionKey === 'favicon_path_admin_portal') {
      this.configurationOptionService.deleteOneWithFile(this.faviconAdminPortal)
    } else if (configOptionKey === 'favicon_path_consumer_frontend') {
      this.configurationOptionService.deleteOneWithFile(
        this.faviconConsumerFrontend
      )
    }
  }
}
